// TN-09S Style 41 Bobbins
import React from "react";
import {
   BackPressureSpringRow, CommonRows, FeederTensionSettingRow, FeederWrapsRow, ImpulseSettingRow, InputRangeRow,
   LayWheelSettingRow, LubeRollerRow, RunTimeRow, TensionPostSettingRow, TensionRow, YardsRow
} from "./index";

export default function MachineTainingS41() {
   return (
      <>
         <ImpulseSettingRow />
         <RunTimeRow />
         <InputRangeRow
            titleProp={"Speed"}
            descriptionProp={"rpm"}
            sizeProp={4}
            typeProp={"text"}
            minProp={600}
            maxProp={3000}
            propertyNameProp={"speed"}
            errorDialogueProp={"600-3000 only"}
            floatProp={false}
         />
         <LubeRollerRow />
         <TensionRow />
         <InputRangeRow
            titleProp={"Underwind B"}
            descriptionProp={"sec"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={11}
            propertyNameProp={"underwindB"}
            errorDialogueProp={"0-11 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Underwind T"}
            descriptionProp={"sec"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={5}
            propertyNameProp={"underwindT"}
            errorDialogueProp={"0-5 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Underwind D"}
            descriptionProp={"sec"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={11}
            propertyNameProp={"underwindD"}
            errorDialogueProp={"0-11 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Underwind K"}
            descriptionProp={"sec"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={5}
            propertyNameProp={"underwindK"}
            errorDialogueProp={"0-5 only"}
            floatProp={false}
         />
         <LayWheelSettingRow />
         <TensionPostSettingRow />
         <BackPressureSpringRow />
         <FeederTensionSettingRow />
         <FeederWrapsRow />
         <YardsRow />
         <CommonRows />
      </>
   );
}
